module.exports = {
    //通用
    x_mh:":",
    x_fh:";",
    huoma:{
        create_time:"create time",
        create_group_type:"create group type",
        remark : "remark",
        group_huoma:"group huocode",
        huoma_name_and_number:"活码名称/编码",
        huoma_name:"活码名称",
        group_num:"群数量",
        scan_num:"扫码数",
        longer_num:"长按识别数",
        huoma_status:"活码状态",
        operation : "操作",
    }
};



// WEBPACK FOOTER //
// ./src/utils/lang/en.js